var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncreaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.423 11.1552C6.42359 11.5676 6.74588 11.8724 7.15334 11.8724C7.56021 11.873 7.87405 11.5306 7.87346 11.1181L7.86733 5.08036L9.53451 6.76182C9.82238 7.05349 10.2893 7.05406 10.5772 6.76239C10.8648 6.47131 10.8642 5.99853 10.576 5.70686L7.70488 2.79952L7.68446 2.77939C7.55 2.63181 7.35634 2.53965 7.14225 2.53906C6.92817 2.53906 6.73538 2.63065 6.60063 2.77823L6.5805 2.79893L3.71605 5.69897C3.42875 5.99006 3.42934 6.46286 3.7175 6.75452C4.00596 7.04736 4.47233 7.04735 4.76021 6.75627L6.41658 5.1174L6.423 11.1552Z",
    fill: "#02C3AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseIcon);
export default __webpack_public_path__ + "static/media/increase_icon.02dc8ac2d71b147aeeed9be6da36da37.svg";
export { ForwardRef as ReactComponent };